package ru.malygin.myConst

private const val debug = "debug"
private const val release = "release"



enum class Versions(
    val versionName: String,
    val shortName: String,
) {
    DEBUG(
        versionName = debug,
        shortName = "dev"
    ),
    RELEASE(
        versionName = release,
        shortName = "prod"
    )
}


private val debugList = listOf(Versions.DEBUG) // дополнять с новыми версиями
private val releaseList = listOf(Versions.RELEASE) // дополнять с новыми версиями

// JS

/**
 * Обозначение версии js
 */
private val jsMainMode: Versions = OnTopVariable.APP_MODE // изменять // net!

/**
 * (ЗАКРЫТАЯ)
 *
 * Проверка наличия версии js в списке
 */
private fun jsMainIsVersionFun(vList: List<Versions>): Boolean = jsMainMode in vList

/**
 * (ОТКРЫТАЯ)
 *
 * Проверка, что версия js DEBUG
 */
val jsMainIsDebug: Boolean = jsMainMode == Versions.DEBUG

/**
 * (ОТКРЫТАЯ)
 *
 * Функция выполняемая с определёнными версиями js
 *
 * по умолчанию версия js [debugList]
 */
fun jsMainDebugUnit(
    forVersions: List<Versions> = debugList,
    funK:() -> Unit
) {
    if (jsMainIsVersionFun(forVersions)){
        funK()
    }
}

// JS --